// value is the label for the file type in key
export const allowedFileTypesForAiGrading = {
  txt: 'txt',
  text: 'text',
  doc: 'doc',
  docx: 'docx',
  pdf: 'pdf',
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg',
  jfif: 'jfif',
  webp: 'webp',
  gif: 'gif (non-animated)',
  bmp: 'bmp',
  tiff: 'tiff',
  tif: 'tif',
  bash: 'bash',
  bat: 'bat',
  c: 'c',
  cpp: 'cpp',
  css: 'css',
  go: 'go',
  htm: 'htm',
  html: 'html',
  java: 'java',
  json: 'json',
  jsp: 'jsp',
  jsx: 'jsx',
  md: 'md',
  php: 'php',
  py: 'py',
  r: 'r',
  scss: 'scss',
  sh: 'sh',
  sml: 'sml',
  sql: 'sql',
  swift: 'swift',
  ts: 'ts',
  tsx: 'tsx',
  xml: 'xml',
  yml: 'yml',
  js: 'js',
} as const;
